// TODO: AddressData this 이슈 수정시 ts-nocheck 제거 필요
import { format, setSeconds, setMilliseconds, parse, isToday, } from 'date-fns/esm';
import ko from 'date-fns/locale/ko';
import { BusinessError, errorCode, } from '@/error';
import AddressFormVM from '@/view-model/AddressFormVM';
import { i18n } from '@/locales';
import nodeEnv from '@/constants/nodeEnv';
import { DB_CLICK_DELAY, keyboardType, sortTypeEnum, timeZoneCode, timezoneOffsetMillis, } from '@/constants/global';
import dateFormatType from '@/constants/dateFormatType';
import { REG_BUSINESS_NUMBER, FORMAT_BANK_ACCOUNT, MASKING_PHONE_NUMBER, INTEGER_REG_EXP, } from './regularExpression';
/**
 * url로 접근 시 정상적인 selectedMonth 인지 확인하기
 * 최소 날짜보다 과거를 url에 입력하면 최소로 자동으로 return
 * 최대 날짜보다 미래를 url에 입력하면 최대로 자동으로 return
 * @param currentSelectedMonth url에 입력한 selectedMonth(YYYY-MM 형식)
 * @param max 최대 입력 가능 selectedMonth(YYYY-MM 형식)
 * @param min 최소 입력 가능 selectedMonth(YYYY-MM 형식)
 */
const setValidSelectedMonth = (currentSelectedMonth, max, min = '') => {
    if (!currentSelectedMonth) {
        return max;
    }
    const maxDate = new Date(max);
    const currentSelectedDate = new Date(currentSelectedMonth);
    if (maxDate < currentSelectedDate) {
        return max;
    }
    const minDate = new Date(min);
    if (!!min && currentSelectedDate < minDate) {
        return min;
    }
    return currentSelectedMonth;
};
/**
 * 시간문자를 분리해서 응답한다. 서버에서 주는 문자열 시간을 ui 표현에 적절하게 변경해서 응답한다.
 * @param {string} timeString 06000800 형태로 받음 -> 6시00분 8시00분을 의미한다.
 * @returns {string} 06:00~08:00 형태로 리턴
 */
export const injectSeparatorTimeString = (timeString) => {
    if (timeString && timeString.length >= 8) {
        return [
            [
                timeString.slice(0, 2),
                timeString.slice(2, 4),
            ].join(':'),
            [
                timeString.slice(-4, -2),
                timeString.slice(-2),
            ].join(':'),
        ].join(' ~ ');
    }
    return '';
};
export const injectSeparatorDateString = (dateString) => {
    if (dateString && dateString.length >= 8) {
        return [
            dateString.slice(0, 4),
            dateString.slice(-4, -2),
            dateString.slice(-2),
        ].join('-');
    }
    return '';
};
/**
 * @param dateString 문자열(ex: 'yyyy-mm-dd')
 * @returns '-'만 삭제된 날짜string
 */
export const removeSeparatorDateString = (dateString) => {
    if (dateString && dateString.length >= 10) {
        return dateString.split('-').join('');
    }
    return '';
};
export const percentSignSuffix = (value) => {
    if (typeof value !== 'number') {
        return '';
    }
    return `${value} %`;
};
/**
 * 시간과 날짜 시간 타입 변환 유틸
 * 날짜 기본 패턴 dateFormatType.DATE
 * 시간 기본 패턴 dateFormatType.TIME
 * @param pattern dateFormat
 */
// export const formatDate = (time: number | Date, pattern = dateFormatType.DATE) => {
export const formatDate = (_time, pattern) => {
    let time = _time;
    if (typeof time === 'string') {
        time = Number(time);
    }
    if (!pattern) {
        throw new Error('pattern is Required');
    }
    if (time) {
        return format(time, pattern, {
            locale: ko,
        });
    }
    return '';
};
const formatPercent = (percent) => `${percent || 0} ${i18n.t('unit.percent')}`;
/**
 * 금액 표기는 currency로 통일
 * https://github.com/barogo/hub-control-room/pull/436#discussion_r1046575588
 */
const currency = (value, options = {}) => {
    let number = 0;
    if (typeof value === 'number') {
        number = value;
    }
    else if (typeof value === 'string') {
        if (options.style === 'decimal') {
            number = Number.parseFloat(value);
        }
        else {
            number = Number.parseInt(value, 10);
        }
    }
    const { noSpace } = options;
    const lcCurrency = i18n.t('common.currency');
    // currencyDisplay: 'name' 일 경우 '대한민국 원' 으로 표현됨
    let result = new Intl.NumberFormat('ko-KR', {
        style: 'currency',
        currency: 'KRW',
        currencyDisplay: 'name',
        minimumFractionDigits: 0,
        ...options,
    }).format(number).replace('대한민국', '')
        .replace('원', lcCurrency);
    if (noSpace) {
        result = result.replace(/\s+/g, '');
    }
    return result;
};
/**
 * alias 여백 없는 통화 표기 간편사용용
 * @param value
 * @returns
 */
const noSpaceCurrency = (value) => currency(value, {
    noSpace: true,
});
const isFunction = (f) => typeof f === 'function';
/**
 * 문자열 내 빈문자 모두 제거
 */
const trimSpace = (string) => {
    if (!string) {
        return '';
    }
    return string?.split(/\s+/).join('');
};
/**
 *  입력값이 문자열(string) 여부
 */
const isString = (value) => typeof value === 'string';
/**
 *  빈 문자열 여부
 * @param {string} value
 */
const isEmptyString = (value) => value === null || value.length === 0;
/**
 * 문자열 내 앞뒤 공백 모두 제거
 * @param {string} text v-field-text text value
 * @returns
 */
export const trimTextField = (text) => ((text && text !== 'null') ? text.trim() : '');
const validateText = (text) => ((text && text !== 'null') ? text : '');
const validateTextWithHypen = (text) => ((text && text !== 'null') ? text : '-');
const validateCountWithHypen = (value) => (value && value !== 'null' ? `${value} ${i18n.t('unit.count')}` : '-');
/**
 *
 * @param { Array } textList 작성될 텍스트
 * @param { Boolean } isSlashExist 문자열 사이에 '/' 출력여부
 * @returns { String } ex) '연구소지사 / B0337'
 */
const addDividerToMultipleTextField = (textList, isSlashExist = true) => {
    const isAllTextExist = textList.every((text) => !!text);
    if (!isAllTextExist) {
        return '-';
    }
    if (isSlashExist) {
        if (textList.length === 2) {
            return `${textList[0]} / ${textList[1]}`;
        }
        return `${textList[0]} / ${textList[1]}, ${textList[2]}`;
    }
    return `${textList[0]}, ${textList[1]}`;
};
/**
 * 여러 텍스트를 컴마로 연결해줌. (null, undefined 섞여도 됨)
 * @param textList ,로 연결할 값들 ex) [null, 'ㅁ', undefined, 'ㅍ']
 * @returns 연결 된 텍스트 'ㅁ, ㅍ'
 */
const addCommaBetweenTextField = (textList, needComma = true) => {
    const space = ' ';
    const joinWord = needComma ? ',' : '';
    const memoText = textList
        .filter((v) => v)
        .join(`${joinWord}${space}`);
    return validateTextWithHypen(memoText);
};
/**
 *
 * @param partialList 부분 리스트
 * @param totalList 전체 리스트
 * @returns { String } ex) '20 / 129' : 129개 중 20개 선택을 의미하는 문자열 반환
 */
const addDividerToMultipleLengthValue = (partialList, totalList) => `${partialList.length}/${totalList.length}`;
const debounce = (callback, limit = 100) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback.apply(this, args);
        }, limit);
    };
};
const throttle = (callback, limit = 100) => {
    let waiting = false;
    return (...args) => {
        if (!waiting) {
            callback.apply(this, args);
            waiting = true;
            setTimeout(() => {
                waiting = false;
            }, limit);
        }
    };
};
/**
 * 값이 선택지(optionList)에 있는 값인지 확인 - 기본 키값 value
 */
const isValidValueByOptionList = (value, optionList, key = 'value') => {
    const isValidValue = optionList.some((option) => option[key] === value);
    return isValidValue;
};
/**
 * 올바른 날짜인지 확인 (25년 2월 31일 / 25년 22월 7일 등 -> NaN -> false)
 */
const isValidDate = (date, _dateFormat) => !Number
    .isNaN(parse(date, _dateFormat, new Date()).getDate());
const paddingPhoneNumber = (input) => {
    if (!input) {
        return '';
    }
    return input.slice(0, -4).padEnd(input.length, '*');
};
export const maskingPhoneNumber = (input) => validateText(input).replace(MASKING_PHONE_NUMBER, '*');
export const formatMaskingPhoneNumber = (input) => {
    // TODO: 자릿수 논의 필요 임시로 작업
    const matched = input.match(/^(\**)(\*{4})(\d{4})$/);
    if (matched) {
        return matched.slice(1).join('-');
    }
    return input;
};
export const formatBankAccount = (input) => {
    const matched = validateText(input).match(FORMAT_BANK_ACCOUNT);
    if (matched) {
        return matched.slice(1).join('-');
    }
    return input;
};
export const formatBusinessNumber = (input) => {
    const matched = validateText(input).match(REG_BUSINESS_NUMBER);
    if (matched) {
        return matched.slice(1).join('-');
    }
    return input;
};
export const addHypenToBusinessNumber = (input) => {
    const result = input.replace(/[^0-9]/g, '')
        .replace(/^(\d{2,3})(\d{2,2})(\d{5})$/, '$1-$2-$3');
    return result;
};
const millisToHoursAndMinutesAndSeconds = (millis) => {
    let remainder = Math.abs(millis) / 1_000;
    const hours = Math.floor(remainder / 3_600);
    remainder -= hours * 3_600;
    const minutes = Math.floor(remainder / 60);
    const seconds = Math.floor(remainder - minutes * 60);
    return [
        hours,
        minutes,
        seconds,
    ];
};
/**
 * 숫자 -> 콤마 추가 된 숫자
 * TODO falsy 케이스에서 빈값 리턴하게 해야할건데.. 20240521 윤태건
 * @returns
 */
const numberToFormatted = (number, options = {
    style: 'decimal',
}) => {
    if (number === null) {
        return null;
    }
    return currency(String(number), options);
};
const formattedToNumber = (_formatted) => {
    let formatted = _formatted;
    if (typeof formatted === 'number') {
        formatted = String(formatted);
    }
    if (formatted !== null) {
        return Number(formatted.replace(/[^0-9.]/g, ''));
    }
    return null;
};
const formattedToInteger = (formatted) => {
    const matched = formatted.match(INTEGER_REG_EXP, '');
    const [firstNumber,] = matched;
    return (formatted !== null ? Number(firstNumber) : null);
};
const isKorean = (text) => {
    const regExp = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;
    return regExp.test(text);
};
const stringToNumber = (strNumber) => {
    const number = Number.parseInt(strNumber, 10);
    return Number.isNaN(number) ? 0 : number;
};
const time2ISOString = () => (new Date(Date.now() - timezoneOffsetMillis)
    .toISOString()
    .substring(0, 10));
// TODO AddressFormVM으로 1.6.0에서 대체 예정
export const getAddressData = ({ inSiDo, inSiGunGu, inEupMyeonDong, inLi, inJibun, inRoad, inBuildingNumber, inBuildingName, inDetail, inLng, inLat, }) => {
    const siDo = validateText(inSiDo);
    const siGunGu = validateText(inSiGunGu);
    const eupMyeonDong = validateText(inEupMyeonDong);
    const li = validateText(inLi);
    const jibun = validateText(inJibun);
    const road = validateText(inRoad);
    const buildingNumber = validateText(inBuildingNumber);
    const buildingName = validateText(inBuildingName);
    const detail = validateText(inDetail);
    const location = {
        longitude: inLng,
        latitude: inLat,
    };
    return {
        siDo,
        siGunGu,
        eupMyeonDong,
        li,
        jibun,
        road,
        buildingNumber,
        buildingName,
        detail,
        location,
        enclosedRoad: road ? `(${road})` : '',
    };
};
/**
 * 다음 좌표 응답값 이용해서 AddressFormVM 생성
 */
export const parseGeocoder = ({ address, roadAddress, x, y, }) => {
    const { enclosedRoad, } = getAddressData({
        inRoad: roadAddress.road_name,
    });
    return new AddressFormVM({
        siDo: address.region_1depth_name,
        siGunGu: address.region_2depth_name,
        dong: address.region_3depth_name,
        // TODO 리 정보를 넣어주는 작업은 1.6.0에 작업할 예정
        li: '',
        jibun: [
            address.main_address_no,
            address.sub_address_no,
        ].filter((landNumber) => landNumber !== '')
            .join('-'),
        road: roadAddress.road_name,
        buildingNumber: [
            roadAddress.main_building_no,
            roadAddress.sub_building_no,
        ].filter((buildingNumber) => buildingNumber !== '')
            .join('-'),
        buildingName: roadAddress.building_name,
        location: {
            longitude: x,
            latitude: y,
        },
        enclosedRoad,
    });
};
export const isEqualsTime = (time1, time2) => setSeconds(setMilliseconds(time1, 0), 0).getTime()
    === setSeconds(setMilliseconds(time2, 0), 0).getTime();
/**
 * 주민등록번호에서 나이를 계산
 * @param {string} frontDigit
 * @param {string} lastDigit
 * @returns {number} 만 나이
 */
export const calculateAgeFromSocialNumber = (socialNumber) => {
    const isValid = () => socialNumber
        && socialNumber.length > 6
        && !Number.isNaN(Number.parseInt(socialNumber, 10));
    if (!isValid()) {
        return 0;
    }
    const frontDigit = socialNumber.substring(0, 6);
    const lastDigit = socialNumber.substring(6);
    // 재외 동포 - 앞자리가 0000
    if (frontDigit.slice(0, 4) === '0000') {
        return 0;
    }
    const year = Number.parseInt(frontDigit.slice(0, 2), 10);
    const birthday = Number.parseInt(frontDigit.slice(2, 6), 10);
    const gender = Number.parseInt(lastDigit.slice(0, 1), 10);
    const nowYear = new Date().getFullYear();
    const nowMonth = new Date().getMonth() + 1;
    const nowDate = new Date().getDate();
    let age = 0;
    // 1800년 ~ 1899년은 고려 X
    // 1900년 ~ 1999년 1,2,5,6
    if ([
        1,
        2,
        5,
        6,
    ].includes(gender)) {
        age = nowYear - 1_900 - year;
    }
    // 2000년 ~ 3,4,7,8
    if ([
        3,
        4,
        7,
        8,
    ].includes(gender)) {
        age = nowYear - 2_000 - year;
    }
    if ((nowMonth * 100 + nowDate) < birthday) {
        age -= 1;
    }
    return age;
};
/**
 * 주민번호 마스킹
 * @param {string} socialNumber 주민번호
 * @param {boolean} isHyphen 주민번호 하이픈 여부
 * @returns {string}
 */
export const socialNumberMasking = (socialNumber, isHyphen = false) => {
    if (!socialNumber) {
        return '';
    }
    const pattern = isHyphen
        ? '^(\\d{6})-(\\d{1})(\\d{6})$'
        : '^(\\d{6})(\\d{1})(\\d{6})$';
    const matched = socialNumber.match(new RegExp(pattern));
    if (matched && matched.length > 3) {
        return `${matched[1]}-${matched[2]}******`;
    }
    return socialNumber;
};
export const socialNumberInputMasking = (socialNumber) => {
    if (!socialNumber) {
        return '';
    }
    if (socialNumber.length < 6) {
        return socialNumber;
    }
    if (socialNumber.length === 6) {
        return `${socialNumber}-`;
    }
    const last6Digits = socialNumber.slice(8);
    // 결과 예시: 123456-7******
    return `${socialNumber.slice(0, 8)}${last6Digits}`;
};
/**
 * v-date-picker title date formatting fucntion
 * @param {string | Array} date  v-date-picker value
 * @returns {string} "{yearInfo}년 {monthInfo}월 {dayInfo}일" | "여러 날짜 선택함"
 */
export const datePickerTitleDateFormat = (date) => {
    if ((date.length === 0)) {
        return null;
    }
    const isArray = Array.isArray(date);
    if (isArray && date.length > 1) {
        return i18n.t('common.multiple_selected');
    }
    const yearInfo = new Date(date).getFullYear();
    const monthInfo = new Date(date).getMonth() + 1;
    const dayInfo = new Date(date).getDate();
    return i18n.t('common.year_month_day', {
        yearInfo,
        monthInfo,
        dayInfo,
    });
};
/**
 * v-date-picker week formatting fucntion
 * @param {string | Array} date  v-date-picker value
 * @returns {string} 'S', 'M', 'T', 'W', 'T', 'F', 'S' 중 하나
 */
export const datePickerWeekFormat = (date) => {
    const weeks = [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S',
    ];
    const i = new Date(date).getDay();
    return weeks[i];
};
/**
 * v-date-picker day formatting fucntion
 * @param {string | Array} date  v-date-picker value
 * @returns {string} 예를 들어 '1'
 */
export const datePickerDayFormat = (date) => {
    const days = new Date(date).getDate();
    return days;
};
/**
 * 로직 지연
 */
export const sleep = (amount = 0) => new Promise((resolve) => setTimeout(resolve, amount));
/**
 * 애니메이션 완료 시점 대응
 * sleep 별칭
 * @param amount ms 기본값 500. 트랜지션 제거되는 시간을 기본값으로 설정
 */
export const waitTransition = async () => sleep(500);
/**
 * 지연 시간 계산
 * @param {*} orderedAt
 * @param {*} shareDelaySecond
 * @returns {number}
 */
export const calcDelay = (orderedAt, shareDelaySecond) => {
    if (!shareDelaySecond) {
        return 0;
    }
    const visibleTime = (orderedAt + (shareDelaySecond * 1000)) - Date.now();
    if (visibleTime < 0) {
        return 0;
    }
    return visibleTime;
};
/**
 * 커스텀 더블 클릭 핸들러
 * 싱글 클릭과 더블 클릭이 충복되지 않도록 커스텀 핸들러 추가 (예: 지도관제 라이더 클릭 or 상세 정보 기능)
 * @param {function} singleClick
 * @param {function} doubleClick
 * @returns {function}
 */
export const setDbClickHandler = (singleClick = () => { }, doubleClick = () => { }) => {
    let clickCount = 0;
    let timer = null;
    return (singleClickParam, doubleClickParam) => {
        clickCount += 1;
        if (clickCount === 1) {
            timer = setTimeout(() => {
                clickCount = 0;
                singleClick(singleClickParam);
            }, DB_CLICK_DELAY);
        }
        if (clickCount === 2) {
            doubleClick(doubleClickParam);
            clearTimeout(timer);
            clickCount = 0;
        }
    };
};
/**
 * 배달 아이템 병합
 * @param {Object} source1
 * @param {Object} source2
 * @returns {Object} 병합된 배달 아이템
 */
export const mergeOrder = (source1, source2) => {
    const keySet = new Set([
        ...Object.keys(source1),
        ...Object.keys(source2),
    ]);
    return [
        ...keySet,
    ]
        .reduce((acc, key) => {
        acc[key] = {
            ...source1[key],
            ...source2[key],
        };
        return acc;
    }, {});
};
export const delayShareDisplay = ({ agencyShareInfo, orderedAt }) => {
    if (agencyShareInfo) {
        const { shareDisplayYn, shareDelaySecond } = agencyShareInfo;
        if (shareDisplayYn === 'Y') {
            const displayTime = orderedAt + (shareDelaySecond * 1_000);
            const delay = displayTime - Date.now();
            return sleep(delay);
        }
    }
    return Promise.resolve();
};
/**
 * 콘솔 로그 커스텀
 */
export const initCustomConsoleLog = () => {
    const { log } = console;
    console.log = (...arg) => {
        if (process.env.VUE_APP_ENV === nodeEnv.PRODUCTION) {
            return;
        }
        // TODO: 추후 로그 서버로 변경
        log.apply(console, Array.from(arg));
    };
};
export const assertValidForm = (isValid, errorMessage, errorMessageProps) => {
    if (!isValid) {
        throw new BusinessError({
            code: errorCode.BAD_REQUEST,
            message: errorMessage,
            reason: errorMessageProps,
        });
    }
};
const remainingTimeSuffix = (text) => {
    const sign = text.startsWith('-');
    if (sign) {
        return i18n.t('common.negative_suffix_remaining_time', {
            remainingTime: text.replace('-', ''),
        }).toString();
    }
    return i18n.t('common.suffix_remaining_time', {
        remainingTime: text,
    }).toString();
};
const convertKebabToSnakeCase = (str) => {
    const snakeStr = str.replace(/-/g, '_');
    return snakeStr;
};
const convertCamelToSnakeCase = (str) => {
    const pascalStr = str.charAt(0).toUpperCase() + str.slice(1);
    const snackeStr = pascalStr.replace(/([A-Z])/g, (tmp) => `_${tmp}`.toLowerCase()).replace(/^_/, '');
    return snackeStr;
};
const convertPascalToSnakeCase = (str) => {
    const snackeStr = str.replace(/([A-Z])/g, (tmp) => `_${tmp}`.toLowerCase()).replace(/^_/, '');
    return snackeStr;
};
const convertEnumToSnakeCase = (str) => {
    const snakeStr = str.toLowerCase();
    return snakeStr;
};
const convertSnakeToKebabCase = (str) => {
    const kebabStr = str.replace(/_/g, '-');
    return kebabStr;
};
const convertSnakeToCamelCase = (str) => {
    const camelStr = str.toLowerCase()
        .replace(/(_\w)/g, (m) => m.toUpperCase().replace('_', ''));
    return camelStr;
};
const convertSnakeToPascalCase = (str) => {
    const camelStr = convertSnakeToCamelCase(str);
    const pascalStr = camelStr.charAt(0).toUpperCase() + camelStr.slice(1);
    return pascalStr;
};
const convertSnakeToEnumCase = (str) => {
    const enumStr = str.toUpperCase();
    return enumStr;
};
/**
 * string을 각 타입으로 변환합니다.
 * caseType = 'snake' | 'kebab' | 'camel' | 'pascal'
 * @param str - 변환 할 string (ex. 'convert-case')
 * @param sourceCase - 현재 case (ex. 'kebab')
 * @param targetCase - 결과물 case (ex. 'camel')
 * @returns string (ex.'convertCase')
 */
const convertCase = (_str, sourceCase, targetCase) => {
    let str = _str;
    switch (sourceCase) {
        case 'snake':
            break;
        case 'kebab':
            str = convertKebabToSnakeCase(str);
            break;
        case 'camel':
            str = convertCamelToSnakeCase(str);
            break;
        case 'pascal':
            str = convertPascalToSnakeCase(str);
            break;
        case 'enum':
            str = convertEnumToSnakeCase(str);
            break;
        default:
            break;
    }
    switch (targetCase) {
        case 'snake':
            return str;
        case 'kebab':
            return convertSnakeToKebabCase(str);
        case 'camel':
            return convertSnakeToCamelCase(str);
        case 'pascal':
            return convertSnakeToPascalCase(str);
        case 'enum':
            return convertSnakeToEnumCase(str);
        default:
            return str;
    }
};
/**
 * v-text-field onBlur event 시 emit을 통해 해당 field value trim하기
 * @param {string} fieldName
 * @param {*} fieldValue
 * @param {Function} emit
 */
export const onBlurTrimTextField = (fieldName, fieldValue, emit) => {
    emit('setFormData', fieldName, trimTextField(fieldValue));
};
export const setErrorMessageData = (errorMessageData, fieldName, message) => {
    // eslint-disable-next-line no-param-reassign
    errorMessageData[fieldName] = message;
};
/*
 * 00000000 패턴을 startEndString으로 명명 (가칭)
 * 두번째 인자가 utc 입력시 kr이 온다고 가정 함.
 * 두번째 인자가 kr이 오면 utc로 변경 될 것으로 가정 함.
 * @param {string} 00000000 8개 문자열 받음.
 * @param {string} 타임존
 * @returns {string} 타임존 적용된 시간으로 변경해서 리턴 00000000
 */
export const changeStartEndStringTimeZone = (startEndTimeString, timeZone = timeZoneCode.UTC) => {
    const timeZoneMapper = {
        [timeZoneCode.UTC]: -9,
        [timeZoneCode.KR]: 9,
    };
    if (typeof startEndTimeString !== 'string' || startEndTimeString.length < 8) {
        throw new Error('startEndTimeString 오류');
    }
    const oneDay = 24;
    const timeDiff = timeZoneMapper[timeZone];
    const middle = startEndTimeString.length / 2;
    const startTime = startEndTimeString.slice(0, middle);
    const startTimeHour = startTime.slice(0, 2);
    const startTimeMinute = startTime.slice(2);
    const endTime = startEndTimeString.slice(middle);
    const endTimeHour = endTime.slice(0, 2);
    const endTimeMinute = endTime.slice(2);
    const restString = [
        startTimeMinute,
        endTimeMinute,
    ];
    const sum = [
        startTimeHour,
        endTimeHour,
    ].reduce((acc, _it, index) => {
        let it = Number(_it);
        // utc로 변경시에 24시 추가
        if (timeZone === timeZoneCode.UTC) {
            it += oneDay;
        }
        // 00시에서 제거하지 않도록 24를 처음에 추가
        let result = Math.abs(it + timeDiff);
        if (result > oneDay) {
            result -= oneDay;
        }
        if (result === oneDay) {
            result = 0;
        }
        if (result < 10) {
            result = `0${result}`;
        }
        // 뒤에 분 추가
        result += restString[index];
        acc.push(result);
        return acc;
    }, []);
    return sum.join('');
};
/**
 * 글자 하나의 byte 계산 (한글 2byte/한자 2byte/그 외 1byte)
 * @param {number} decimal 입력문자(한 글자)에 대한 UTF-16코드
 * @returns {number} 글자 한개의 byte
 */
export const getByteLength = (decimal) => {
    const LINE_FEED = 10; // '\n'
    // eslint-disable-next-line no-bitwise
    return (decimal >> 7) || (LINE_FEED === decimal) ? 2 : 1;
};
/**
 * 전체 byte 계산
 * @param {string} inputText 사용자 입력값
 * @returns {number} 입력된 문자열의 총 byte 수
 */
export const getByte = (inputText) => {
    if (!isString(inputText)) {
        return 0;
    }
    const result = inputText
        .split('')
        .map((s) => s.charCodeAt(0))
        .reduce((prev, unicodeDecimalValue) => prev + getByteLength(unicodeDecimalValue), 0);
    return result;
};
/**
 * maxByte 길이만큼 자른 텍스트 반환함수
 * @param {string} inputText 사용자 입력값
 * @param {number} maxByte 입력가능한 최대 바이트
 * @returns {string} 최대 바이트 수에 맞게 잘린 텍스트
 */
export const getLimitedByteText = (inputText, maxByte) => {
    if (!isString(inputText)) {
        return inputText;
    }
    const characters = inputText.split('');
    let validText = '';
    let totalByte = 0;
    for (let i = 0; i < characters.length; i += 1) {
        const character = characters[i];
        const decimal = character.charCodeAt(0);
        const byte = getByteLength(decimal);
        // 현재까지의 바이트 길이와 더해 최대 바이트 길이를 넘지 않을 때까지만 더하기
        if (totalByte + byte <= maxByte) {
            totalByte += byte; // 현재까지의 총 바이트
            validText += character; // 현재까지의 총 문자열 값
        }
    }
    return validText;
};
/**
 *
 * @param {string} inputValue 사용자가 입력하는 value
 * @param {number} maxByte 최대 바이트 수
 * @param {Object} ref 사용하는 곳의 ref.value, VueComponent 객체
 * @returns {string} 최대 바이트 수에 맞게 잘린 텍스트
 */
export const setLimitedByteText = (inputText, maxByte, ref) => {
    if (!isString(inputText)) {
        return inputText;
    }
    const isValidByte = getByte(inputText) <= maxByte;
    const validValue = isValidByte
        ? inputText
        : getLimitedByteText(inputText, maxByte);
    if (!isValidByte) {
        // eslint-disable-next-line no-param-reassign
        ref.lazyValue = validValue;
    }
    return validValue;
};
/**
 * setLimitedByteText 간소화 버전
 * @param inputText
 * @param maxByte
 * @returns 바이트 기준으로 잘린 값
 */
export const setLimitedByteTextSimple = (inputText, maxByte) => (getLimitedByteText(inputText, maxByte));
// 컴포넌트 초기화 객체 생성
export const makeComponentInfoList = (componentName, title) => ({
    componentName,
    title,
});
export const sortStringWithSortType = (str1, str2, type) => {
    if (type === sortTypeEnum.ASC) {
        return str1.toLowerCase() < str2.toLowerCase() ? -1 : 1;
    }
    return str1.toLowerCase() > str2.toLowerCase() ? -1 : 1;
};
/**
 * dispatch를 위한 actionType 경로 자동 변환기, getter 경로에서도 사용
 * 예시)
 * vuexStore.dispatch(dispatchActionType.dialogClose);
 * @param actionType 해당 스토어의 actionType 전달
 * @param path 스토어 이름
 * @returns
 */
export const vuexEventPathGenerator = (actionType, path) => Object.keys(actionType).reduce((acc, it) => {
    acc[it] = `${path}/${it}`;
    return acc;
}, {});
/**
 * 액션 찾아가지 못해서 폐기.. 그러나 일단 히스토리 차원에서 남김.
 * 액션, 뮤테이션, 게터등 타입을 객체로 만드는 것이 귀찮아서 만든 유틸
 * 타입 배열을 타입이 지정된 객체로 만들어 준다
 * 배열을 as const 해서 보내면 된다.
 * @param v
 * @returns
 */
export const vuexEventTypeGenerator = (v) => v
    .reduce((acc, it) => {
    acc[it] = it;
    return acc;
}, {});
/**
 * range picker용 데이터 생성
 * @param _period
 * @returns
 */
export const makeRangePickerDate = (_period, _dateFormat = dateFormatType.DATE) => {
    const period = [
        ..._period,
    ];
    if (period.length === 1) {
        period.push(period[0]);
    }
    // 0. 2개의 값(기간)을 선택해야 함.
    if (!period[1]) {
        period.splice(1, 1, period[0]);
    }
    const [d1, d2,] = period.map((it) => parse(it, _dateFormat, new Date()).getTime());
    if (d1 - d2 <= 0) {
        return period;
    }
    return period.reverse();
};
/**
 * 코드를 받아서 문자로 변환
 * @param args
 * @returns
 */
export const toChar = (code) => keyboardType[code];
/**
 * 오늘이면 brg-color-red로 표기
 * @returns
 */
export const isTodayTextColor = (date) => {
    if (isToday(date)) {
        return 'brg-color-red-700';
    }
    return '';
};
/**
 * 문자열 정렬
 * @param str1
 * @param str2
 * @param sortType
 * @returns
 */
export const sortString = (str1, str2, sortType = 'ko-KR') => str1.localeCompare(str2, sortType);
export { setValidSelectedMonth, remainingTimeSuffix, formatPercent, currency, noSpaceCurrency, isFunction, isString, isEmptyString, validateText, validateTextWithHypen, validateCountWithHypen, addDividerToMultipleTextField, addCommaBetweenTextField, addDividerToMultipleLengthValue, debounce, throttle, paddingPhoneNumber, millisToHoursAndMinutesAndSeconds, numberToFormatted, formattedToNumber, formattedToInteger, stringToNumber, time2ISOString, isValidDate, isValidValueByOptionList, trimSpace, isKorean, convertCase, };
